import React from 'react'
import {Card, CardContent} from '@/components/ui/card'
import PropTypes from 'prop-types'
import {BodyCopy} from '@/components/ui/body-copy'
import {cn} from '@/lib/utils'
import {Button, routeTypes} from '@/components/ui/button'
import {useFetchBuilderReference} from '@/builder/hooks/useFetchBuilderReference'
import modelMap from 'hec/builder/model-map'

export const CustomArticleTopicCard = (props) => {
    const {articleTopicRef, attributes} = props
    const {className, ...restAttributes} = attributes || {}

    const shouldQueryArticleTopic = !articleTopicRef?.value?.data

    const {data: articleTopicData, error: articleTopicError} = useFetchBuilderReference({
        model: modelMap.learningCenterArticleTopic,
        shouldQuery: shouldQueryArticleTopic,
        referenceId: articleTopicRef?.id,
        fields: 'data'
    })

    const articleTopic = shouldQueryArticleTopic
        ? articleTopicData?.data
        : articleTopicRef?.value?.data

    const imageUrl = articleTopic?.image
    const articleTitle = articleTopic?.title
    const articleId = articleTopic?.id
    const hrefValue = `/learning-center/articles?topic=${articleId}`

    if (shouldQueryArticleTopic && articleTopicError) {
        console.error(`An error occurred while fetching article topic data: `, articleTopicError)
    }

    return (
        <Card
            className={cn('shadow-none border-none', className)}
            {...restAttributes}
            data-testid="articleTopicCard"
        >
            <Button
                hrefValue={hrefValue}
                type={routeTypes.INTERNAL}
                asChild
                data-testid="articleTopicCard-Button"
            >
                <CardContent data-testid="articleTopicCard-CardContent">
                    <div className="relative overflow-hidden">
                        <img
                            src={imageUrl}
                            alt={articleTitle}
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-primary/75 p-3 flex flex-col justify-start lg:h-20 h-16">
                            <BodyCopy
                                className="text-white text-md lg:text-lg !font-medium text-center"
                                data-testid="articleTopicCard-BodyCopy"
                            >
                                {articleTitle}
                            </BodyCopy>
                        </div>
                    </div>
                </CardContent>
            </Button>
        </Card>
    )
}

CustomArticleTopicCard.propTypes = {
    attributes: PropTypes.object,
    articleTopicRef: PropTypes.shape()
}

export const ArticleTopicCardDefinition = {
    component: CustomArticleTopicCard,
    name: 'ArticleTopicCard',
    noWrap: true,
    inputs: [
        {
            name: 'articleTopicRef',
            type: 'reference',
            model: 'learning-center-article-topic',
            friendlyName: 'Select Article Topic',
            required: true
        }
    ]
}
